import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@london-life/ui/components/dialog';
import { api, twoStepRequests, type TwoStepRequest } from '../lib/api';
import { CodeForm } from './code-form';

// before a dangerous action, the API may ask for a fresh code; this asks for it, then the action is retried
export function TwoStepPrompt() {
  const [pending, setPending] = useState<TwoStepRequest | null>(null);
  // stored with an updater: handing a function straight to setState would make React call it
  useEffect(() => twoStepRequests.listen((resolve) => setPending(() => resolve)), []);
  const finish = (verified: boolean) => {
    pending?.(verified);
    setPending(null);
  };
  return (
    <Dialog open={pending !== null} onOpenChange={(open) => !open && finish(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm it is you</DialogTitle>
          <DialogDescription>
            For your safety, enter a fresh code from your authenticator app to continue.
          </DialogDescription>
        </DialogHeader>
        <CodeForm
          submitLabel="Confirm"
          onSubmit={async (body) => {
            await api.admin.twoStep.verify(body);
            finish(true);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
